var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c(
        "div",
        { staticClass: "layout_nav" },
        [_c("Nav", _vm._b({}, "Nav", _vm.getRol, false))],
        1
      ),
      _vm.loadBar == true
        ? _c("SkeletonDevice")
        : _c("div", { staticClass: "layout_center" }, [
            _c("div", { staticClass: "layout_row" }, [
              _c(
                "div",
                { staticClass: "layout_colum" },
                [
                  _c("Snackbar", {
                    attrs: {
                      visible: _vm.getAlert.snackbar,
                      text: _vm.getAlert.text,
                    },
                  }),
                ],
                1
              ),
            ]),
            this.getQueyDevice != null
              ? _c("div", [
                  _c("div", { staticClass: "data_device_page" }, [
                    _c(
                      "div",
                      { staticClass: "data_device_page_colum medium_35" },
                      [
                        _c(
                          "div",
                          { staticClass: "data_device_map" },
                          [
                            _c(
                              "l-map",
                              {
                                staticClass: "style_map",
                                attrs: { zoom: this.zoom, center: _vm.coorde },
                              },
                              [
                                _c("l-tile-layer", {
                                  attrs: {
                                    url: _vm.url,
                                    attribution: _vm.attribution,
                                  },
                                }),
                                _c(
                                  "l-marker",
                                  { attrs: { "lat-lng": _vm.coorde } },
                                  [
                                    _c("l-popup", [
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getQueyDevice.nui) +
                                            " "
                                        ),
                                        _vm.getQueyDevice.typeDevice !=
                                        "Lora-Wan"
                                          ? _c("div", [
                                              _vm.getQueyDevice.profile ==
                                              "post"
                                                ? _c("span", [
                                                    _vm._v("POSTPAGO"),
                                                  ])
                                                : _vm._e(),
                                              _vm.getQueyDevice.profile == "pre"
                                                ? _c("span", [
                                                    _vm._v("PREPAGO"),
                                                  ])
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "data_device_page_colum" }, [
                      _c("div", { staticClass: "data_device_indicator px-6" }, [
                        _c("div", { staticClass: "item_indicator" }, [
                          _c("div", [
                            _vm.getQueyDevice.activate == 1
                              ? _c("span", { staticClass: "device_active" }, [
                                  _vm._v("Activo"),
                                ])
                              : _c("span", { staticClass: "device_inactive" }, [
                                  _vm._v("Inactivo"),
                                ]),
                          ]),
                          _c("div", [
                            _vm.getQueyDevice.state == true
                              ? _c("span", { staticClass: "device_active" }, [
                                  _vm._v("Conectado"),
                                ])
                              : _c("span", { staticClass: "device_inactive" }, [
                                  _vm._v("Desconectado"),
                                ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "item_indicator_battery" }, [
                          _vm.levelBattery == 100
                            ? _c(
                                "span",
                                [
                                  _c("v-icon", [_vm._v("mdi-battery")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("battery")(_vm.levelBattery)
                                      ) +
                                      "% "
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "span",
                                [
                                  _c(
                                    "v-icon",
                                    { staticStyle: { color: "#f50" } },
                                    [_vm._v("mdi-battery-50")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("battery")(_vm.levelBattery)
                                      ) +
                                      "% "
                                  ),
                                ],
                                1
                              ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "item_indicator_actions" },
                          [
                            _c(
                              "v-menu",
                              {
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "table_menu",
                                                  attrs: { color: "primary" },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(" Acciones "),
                                              _c("v-icon", [
                                                _vm._v("mdi-menu-down"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2998331226
                                ),
                              },
                              [
                                _c(
                                  "v-list",
                                  [
                                    _c(
                                      "v-list-item",
                                      { staticClass: "list_action" },
                                      [
                                        _vm.getQueyDevice.switch == false
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "on_line",
                                                attrs: { plain: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.switchItem(
                                                      _vm.getQueyDevice
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v(" mdi-power"),
                                                ]),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getQueyDevice
                                                        .subTypeService ===
                                                        "Energia"
                                                        ? "On"
                                                        : "Open"
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "v-btn",
                                              {
                                                staticClass: "off_line",
                                                attrs: { plain: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.switchItem(
                                                      _vm.getQueyDevice
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v(" mdi-power"),
                                                ]),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getQueyDevice
                                                        .subTypeService ===
                                                        "Energia"
                                                        ? "Off"
                                                        : "Close"
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "list_action" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "cent",
                                            attrs: { plain: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.limitItem(
                                                  _vm.getQueyDevice
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("CREAR LIMITE")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "list_action" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { plain: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.scheduleItem(
                                                  _vm.getQueyDevice
                                                )
                                              },
                                            },
                                          },
                                          [_c("span", [_vm._v("Programar")])]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "list_action" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { plain: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.takeItem(
                                                  _vm.getQueyDevice
                                                )
                                              },
                                            },
                                          },
                                          [_c("span", [_vm._v("lectura")])]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "list_action" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "cent",
                                            attrs: { plain: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.configItem(
                                                  _vm.getQueyDevice
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Configuración")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      { staticClass: "list_action" },
                                      [
                                        _vm.getQueyDevice.state == true
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: { plain: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.connectItem(
                                                      _vm.getQueyDevice
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Deshabilitar"),
                                                ]),
                                              ]
                                            )
                                          : _c(
                                              "v-btn",
                                              {
                                                attrs: { plain: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.connectItem(
                                                      _vm.getQueyDevice
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Habilitar"),
                                                ]),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "indicator_num" }, [
                        _c("div", { staticClass: "ind_logo" }, [
                          _c("p", [
                            _c("b", [_vm._v(_vm._s(_vm.getQueyDevice.idx))]),
                          ]),
                          _vm.getQueyDevice.subTypeService != "Seguridad"
                            ? _c("p", [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/electric-meter_1.svg"),
                                    alt: "",
                                  },
                                }),
                              ])
                            : _c("p", [
                                _vm.getQueyDevice.typeDeviceS ==
                                "Sensor de Humo"
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/detector-smoke.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.getQueyDevice.typeDeviceS ==
                                "Sensor de Puerta"
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/sensor-door.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.getQueyDevice.typeDeviceS ==
                                "Boton de Panico"
                                  ? _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/button_panic.svg"),
                                        alt: "",
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                          _c("p", [
                            _c("b", [
                              _vm._v(_vm._s(_vm.getQueyDevice.subTypeService)),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "indicator_num_display _medium" },
                          [
                            _c("div", {}, [
                              _vm.getQueyDevice.profile == "post"
                                ? _c("span", [_vm._v("POSTPAGO")])
                                : _vm._e(),
                              _vm.getQueyDevice.profile == "pre"
                                ? _c("span", [_vm._v("PREPAGO")])
                                : _vm._e(),
                            ]),
                            _vm.getQueyDevice.subTypeService != "Seguridad"
                              ? _c("div", [
                                  _c("p", [_vm._v("Lectura Medidor")]),
                                  _c("p", { staticClass: "num_indi" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("threeDigit")(
                                          _vm.getQueyDevice.infoNodo.Data
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _c("p", { staticClass: "caption" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDateFrom")(
                                    _vm.getQueyDevice.updateAt
                                  )
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "ctn_off_data" }, [
                              _vm.getQueyDevice.switch == true
                                ? _c(
                                    "span",
                                    { staticClass: "off_data online" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getQueyDevice.subTypeService ===
                                            "Energia"
                                            ? "On"
                                            : "Open"
                                        )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "off_data offline" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getQueyDevice.subTypeService ===
                                            "Energia"
                                            ? "Off"
                                            : "Closed"
                                        )
                                      ),
                                    ]
                                  ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "indicator_num _columns _medium" },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { left: "", "max-width": "200px" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "indicator_num_display _box",
                                                },
                                                "div",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("p", [
                                                _vm._v("Consumo Anterior"),
                                              ]),
                                              _vm.takeLastData !== null
                                                ? _c("div", [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text_normal mb-0",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.takeLastData.valUsage
                                                                .toFixed(3)
                                                                .toString()
                                                                .replace(
                                                                  ".",
                                                                  ","
                                                                )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.takeLastData
                                                                .unitValUsage
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass: "caption",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.takeLastData
                                                              .period.name
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text_normal",
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1947889651
                                ),
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "max-width": "50px" } },
                                  [
                                    _vm._v(
                                      "Consumo total del último periodo leido"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { left: "", "max-width": "200px" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "indicator_num_display _box",
                                                },
                                                "div",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("p", [
                                                _vm._v("Consumo Actual"),
                                              ]),
                                              _c(
                                                "p",
                                                { staticClass: "text_normal" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.getTotalConsumo
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4005590256
                                ),
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "max-width": "50px" } },
                                  [
                                    _vm._v(
                                      "Consumo total desde la última lectura realizada"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { left: "", "max-width": "200px" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "indicator_num_display _box",
                                                },
                                                "div",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("p", [
                                                _vm._v("Consumo del dia"),
                                              ]),
                                              _c(
                                                "p",
                                                { staticClass: "text_normal" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("twoDigit")(
                                                          _vm.getQueyDevice
                                                            .CounterToday
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  241662308
                                ),
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "max-width": "50px" } },
                                  [
                                    _vm._v(
                                      "Consumo del día a partir de las 12:00 a.m."
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "indicator_num _columns _medium" },
                          [
                            _c(
                              "div",
                              { staticClass: "indicator_num_display _box" },
                              [
                                _c("p", [_vm._v("Limite establecido")]),
                                _vm.getQueyDevice.historyLimit.check != false
                                  ? _c(
                                      "div",
                                      { staticClass: "indicator_itm" },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "text_normal" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getQueyDevice.historyLimit
                                                    .limit
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { small: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteItem(
                                                  _vm.getQueyDevice
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("quitar")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _c("p", { staticClass: "text_normal" }, [
                                        _vm._v("Ninguno"),
                                      ]),
                                    ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "indicator_num_display _box" },
                              [
                                _c("p", [_vm._v("Programado")]),
                                _vm.getQueyDevice.schedule != undefined
                                  ? _c(
                                      "div",
                                      { staticClass: "indicator_itm" },
                                      [
                                        _vm.getQueyDevice.schedule
                                          .scheduledActive != false
                                          ? _c(
                                              "div",
                                              { staticClass: "ctn_ind" },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "text_normal",
                                                  },
                                                  [
                                                    _vm.getQueyDevice.schedule
                                                      .scheduledStatus == "On"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "device_active",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .getQueyDevice
                                                                  .subTypeService ===
                                                                  "Energia"
                                                                  ? "On"
                                                                  : "Open"
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "device_inactive",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .getQueyDevice
                                                                  .subTypeService ===
                                                                  "Energia"
                                                                  ? "Off"
                                                                  : "Close"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "text_normal",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            _vm.getQueyDevice
                                                              .schedule
                                                              .scheduledDate
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: { small: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteScheduleItem(
                                                          _vm.getQueyDevice
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("quitar")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticStyle: { width: "100%" },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text_normal text-left",
                                                  },
                                                  [_vm._v("Ninguno")]
                                                ),
                                              ]
                                            ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      { staticStyle: { width: "100%" } },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text_normal text-left",
                                          },
                                          [_vm._v("Ninguno")]
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "indicator_num" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "indicator_num_display _box _medium _movile",
                          },
                          [
                            _c("div", [
                              _c("p", [_vm._v("NUI")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.nui)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Cód. Interno")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.alternateCode)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Estrato")]),
                              _vm.getQueyDevice.socialgroup != undefined
                                ? _c("p", { staticClass: "text_normal" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getQueyDevice.socialgroup.name
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _c("p", [_vm._v("-")]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Zona")]),
                              _vm.getQueyDevice.zone != undefined
                                ? _c("p", { staticClass: "text_normal" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getQueyDevice.zone.name) +
                                        " "
                                    ),
                                  ])
                                : _c("p", [_vm._v("-")]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Ruta")]),
                              _vm.getQueyDevice.road != undefined
                                ? _c("p", { staticClass: "text_normal" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getQueyDevice.road.name) +
                                        " "
                                    ),
                                  ])
                                : _c("p", [_vm._v("-")]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Ciclo")]),
                              _vm.getQueyDevice.cycle != undefined
                                ? _c("p", { staticClass: "text_normal" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getQueyDevice.cycle.name) +
                                        " "
                                    ),
                                  ])
                                : _c("p", [_vm._v("-")]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "indicator_num_display _box _medium _movile",
                          },
                          [
                            _c("div", [
                              _c("p", [_vm._v("Nombre")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.customName)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Serial")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.serial)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Fabricante")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.manufacturer)),
                              ]),
                            ]),
                            _vm.getQueyDevice.subTypeService === "Gas"
                              ? _c("div", [
                                  _c("p", [_vm._v("Caudal")]),
                                  _c("p", { staticClass: "text_normal" }, [
                                    _vm._v(_vm._s(_vm.getQueyDevice.gasFlow)),
                                  ]),
                                ])
                              : _vm._e(),
                            _c("div", [
                              _c("p", [_vm._v("Dispositivo")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.infoNodo.Name)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("NODO PADRE")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.nodeID)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("POSICIÓN DE NODO")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.childID)),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "indicator_num_display _box _medium _movile",
                          },
                          [
                            _c("div", [
                              _c("p", [_vm._v("Empresa")]),
                              _vm.getQueyDevice.company != undefined
                                ? _c("p", { staticClass: "text_normal" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getQueyDevice.company.name) +
                                        " "
                                    ),
                                  ])
                                : _c("p", [_vm._v("-")]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Dirección")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.address)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Ciudad")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.city)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Latitud")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.latitude)),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", [_vm._v("Longitud")]),
                              _c("p", { staticClass: "text_normal" }, [
                                _vm._v(_vm._s(_vm.getQueyDevice.longitude)),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "section_sensor" }, [
                    _c("h4", [_vm._v("Sensores Asociados")]),
                    _c(
                      "div",
                      { staticClass: "child_sensor" },
                      _vm._l(
                        _vm.getQueyNode.filter(
                          (i) => i._id != _vm.getQueyDevice._id
                        ),
                        function (item) {
                          return _c(
                            "div",
                            { key: item._id, staticClass: "indicator_num" },
                            [
                              _c(
                                "div",
                                { staticClass: "indicator_num_display _box" },
                                [
                                  _c("p", { staticClass: "num_indi_date" }, [
                                    _vm._v("idx " + _vm._s(item.idx)),
                                  ]),
                                  _c("p", [_vm._v(_vm._s(item.infoNodo.Name))]),
                                  _c("p", { staticClass: "text_normal" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("threeDigit")(
                                            item.infoNodo.Data
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                  _c("div", { staticClass: "section_graph" }, [
                    _c("div", { staticClass: "ctn_head_graph" }, [
                      _c("div", { staticClass: "head_title_graph" }, [
                        _c("h4", [_vm._v("Grafico")]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "head_indicator_graph" },
                        [
                          _c(
                            "v-btn",
                            {
                              style: [
                                _vm.flagChart == 3
                                  ? {
                                      "background-color": "#06f",
                                      color: "#fff",
                                    }
                                  : {
                                      "background-color": "transparent",
                                      color: "#000",
                                    },
                              ],
                              on: { click: _vm.setChartRange },
                            },
                            [_vm._v("PERSONALIZADO")]
                          ),
                          _c(
                            "v-btn",
                            {
                              style: [
                                _vm.flagChart == 2
                                  ? {
                                      "background-color": "#06f",
                                      color: "#fff",
                                    }
                                  : {
                                      "background-color": "transparent",
                                      color: "#000",
                                    },
                              ],
                              on: { click: _vm.setChartYear },
                            },
                            [_vm._v("AÑO")]
                          ),
                          _c(
                            "v-btn",
                            {
                              style: [
                                _vm.flagChart == 1
                                  ? {
                                      "background-color": "#06f",
                                      color: "#fff",
                                    }
                                  : {
                                      "background-color": "transparent",
                                      color: "#000",
                                    },
                              ],
                              on: { click: _vm.setChartDay },
                            },
                            [_vm._v("HOY")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("div"),
                    _vm.flagChart == 1
                      ? _c(
                          "div",
                          { staticClass: "ctn_chart" },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "6", md: "3" } },
                                  [
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: {
                                          "close-on-content-click": false,
                                          "nudge-right": 40,
                                          transition: "scale-transition",
                                          "offset-y": "",
                                          "min-width": "auto",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            label: "Fecha",
                                                            "prepend-icon":
                                                              "mdi-calendar",
                                                            readonly: "",
                                                            required: "",
                                                          },
                                                          model: {
                                                            value: _vm.date,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.date = $$v
                                                            },
                                                            expression: "date",
                                                          },
                                                        },
                                                        "v-text-field",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          598374356
                                        ),
                                        model: {
                                          value: _vm.menu,
                                          callback: function ($$v) {
                                            _vm.menu = $$v
                                          },
                                          expression: "menu",
                                        },
                                      },
                                      [
                                        _c("v-date-picker", {
                                          ref: "date-picker",
                                          attrs: {
                                            max: new Date()
                                              .toISOString()
                                              .substr(0, 10),
                                          },
                                          on: {
                                            input: function ($event) {
                                              _vm.menu2 = false
                                            },
                                            change: function ($event) {
                                              return _vm.actionDataChartDay({
                                                _id: _vm.getQueyDevice._id,
                                                date: _vm.date,
                                              })
                                            },
                                          },
                                          model: {
                                            value: _vm.date,
                                            callback: function ($$v) {
                                              _vm.date = $$v
                                            },
                                            expression: "date",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "ctn_flow_chart" }, [
                              _c(
                                "div",
                                { staticClass: "flow_chart" },
                                [
                                  _c("LineChart", {
                                    attrs: {
                                      chartData: _vm.getDataChartDay,
                                      options: _vm.chartOptions,
                                      label: "Consumo",
                                      unit: _vm.getUnit,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.flagChart == 2
                      ? _c(
                          "div",
                          { staticClass: "ctn_chart" },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "6", md: "3" } },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.inittahun,
                                        label: "Año",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.actionDataChartYear({
                                            _id: _vm.getQueyDevice._id,
                                            date: _vm.dateYear,
                                          })
                                        },
                                      },
                                      model: {
                                        value: _vm.dateYear,
                                        callback: function ($$v) {
                                          _vm.dateYear = $$v
                                        },
                                        expression: "dateYear",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "ctn_flow_chart" }, [
                              _c(
                                "div",
                                { staticClass: "flow_chart" },
                                [
                                  _c("LineChartYear", {
                                    attrs: {
                                      chartData: _vm.getDataChartYear,
                                      options: _vm.chartOptionsYear,
                                      label: "Consumo",
                                      unit: _vm.getUnit,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.flagChart == 3
                      ? _c(
                          "div",
                          { staticClass: "ctn_chart" },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "6", md: "3" } },
                                  [
                                    _c(
                                      "v-menu",
                                      {
                                        ref: "menuRange",
                                        attrs: {
                                          "close-on-content-click": false,
                                          transition: "scale-transition",
                                          "offset-y": "",
                                          "min-width": "auto",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "prepend-icon":
                                                              "mdi-calendar",
                                                            readonly: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.dateRangeText,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.dateRangeText =
                                                                $$v
                                                            },
                                                            expression:
                                                              "dateRangeText",
                                                          },
                                                        },
                                                        "v-text-field",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          997050416
                                        ),
                                        model: {
                                          value: _vm.menuRange,
                                          callback: function ($$v) {
                                            _vm.menuRange = $$v
                                          },
                                          expression: "menuRange",
                                        },
                                      },
                                      [
                                        _c("v-date-picker", {
                                          ref: "picker",
                                          attrs: {
                                            range: "",
                                            color: "primary",
                                            "header-color": "primary",
                                            max: new Date()
                                              .toISOString()
                                              .substr(0, 10),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.actionDataChartRange({
                                                _id: _vm.getQueyDevice._id,
                                                date: _vm.dateRange,
                                              })
                                            },
                                          },
                                          model: {
                                            value: _vm.dateRange,
                                            callback: function ($$v) {
                                              _vm.dateRange = $$v
                                            },
                                            expression: "dateRange",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "ctn_flow_chart" }, [
                              _c(
                                "div",
                                { staticClass: "flow_chart" },
                                [
                                  _c("LineChartRange", {
                                    attrs: {
                                      chartData: _vm.getDataChartRange,
                                      options: _vm.chartOptionsYear,
                                      label: "Consumo",
                                      unit: _vm.getUnit,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "section_history" },
                    [
                      _c("h4", [_vm._v("HISTORIAL")]),
                      _c("v-select", {
                        staticClass: "tab_header_select",
                        attrs: {
                          items: _vm.itemSelect,
                          "item-value": "id",
                          "item-text": "name",
                          label: "Opciones historico",
                        },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      }),
                      _c(
                        "v-tabs",
                        {
                          staticClass: "tab_header_custom",
                          model: {
                            value: _vm.tab,
                            callback: function ($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab",
                          },
                        },
                        [
                          _c("v-tab", { key: "1" }, [_vm._v("Lecturas")]),
                          _c("v-tab", { key: "2" }, [_vm._v("Notificaciones")]),
                          _c("v-tab", { key: "3" }, [_vm._v("Usuarios")]),
                          _c("v-tab", { key: "4" }, [_vm._v("Switch")]),
                          _c("v-tab", { key: "5" }, [
                            _c("span", [_vm._v("LIMITE")]),
                          ]),
                          _c("v-tab", { key: "6" }, [_vm._v("Programado")]),
                          _c("v-tab", { key: "7" }, [_vm._v("Config")]),
                        ],
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.tab,
                            callback: function ($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            { key: "1" },
                            [_c("TableHistory")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { key: "2" },
                            [_c("TableNotify")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { key: "3" },
                            [
                              _c("TableUser", {
                                attrs: {
                                  list: this.getUserDevice,
                                  device: _vm.getQueyDevice,
                                  updateList: _vm.updateListUsers,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { key: "4" },
                            [_c("TableSwitch")],
                            1
                          ),
                          _c("v-tab-item", { key: "5" }, [_c("TableLimit")], 1),
                          _c(
                            "v-tab-item",
                            { key: "6" },
                            [
                              _c("TableSchedule", {
                                attrs: {
                                  list: this.getQueyDevice.scheduleHistory,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { key: "7" },
                            [
                              _c("TableConfig", {
                                attrs: {
                                  list: this.getQueyDevice.historyConfig,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
      _c("Limit", {
        attrs: { data: _vm.itemObjct, visible: _vm.flagLimit },
        on: {
          close: function ($event) {
            _vm.flagLimit = false
          },
        },
      }),
      _c("DeleteLimit", {
        attrs: { data: _vm.itemObjct, visible: _vm.flagDeleteLimit },
        on: {
          close: function ($event) {
            _vm.flagDeleteLimit = false
          },
        },
      }),
      _c("DeleteSchedule", {
        attrs: { data: _vm.itemObjct, visible: _vm.flagDeleteSchedule },
        on: {
          close: function ($event) {
            _vm.flagDeleteSchedule = false
          },
        },
      }),
      _c("Schedule", {
        attrs: { data: _vm.itemObjct, visible: _vm.flagSchedule },
        on: {
          close: function ($event) {
            _vm.flagSchedule = false
          },
        },
      }),
      _c("Connect", {
        attrs: { data: _vm.itemObjct, visible: _vm.ConnectFlag },
        on: {
          close: function ($event) {
            _vm.ConnectFlag = false
          },
        },
      }),
      _c("TakeRead", {
        attrs: { data: _vm.itemObjct, visible: _vm.TakeFlag },
        on: {
          close: function ($event) {
            _vm.TakeFlag = false
          },
        },
      }),
      _c("SwitchModal", {
        attrs: { data: _vm.itemObjct, visible: _vm.SwitchFlag },
        on: {
          close: function ($event) {
            _vm.SwitchFlag = false
          },
        },
      }),
      _c("ConfigComp", {
        attrs: { data: _vm.itemObjct, visible: _vm.configFlag },
        on: {
          close: function ($event) {
            _vm.configFlag = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }